import { Injectable } from '@angular/core';
import {SessionStorageService} from "@/core/services/internal/session-storage.service";


const USER_KEY = 'current-user-analysis';


@Injectable({
  providedIn: 'root'
})
export class AnalysisStoreService {

  constructor(private sessionStorageService: SessionStorageService) {
  }

  public saveAnalyses(data: any[]): void {
    this.sessionStorageService.deleteItem(USER_KEY);
    this.sessionStorageService.saveItem(USER_KEY, JSON.stringify(data));
  }

  public getAnalyses(): any | null {
    const stored = this.sessionStorageService.getItem(USER_KEY);
    if (!stored) return null;

    return JSON.parse(stored)
  }

  public clear(): void {
    this.sessionStorageService.deleteItem(USER_KEY);
  }
}